export default "__VITE_ASSET__DElO4LiW__"